import React from "react"
import { Option, OptionContainer, OptionLabel } from "../common"
import { FormattedMessage } from "react-intl"

const headerText = (somethingElse, deny, unsure, first) => {
  if (!somethingElse && !deny && !unsure) return "Which is correct?"
  else if (somethingElse && unsure && first)
    return "Which do you think is the right answer?"
  else if (deny && unsure) return "Did we get it right?"
  else return "What did it end up being?"
}

const DiagnosisSelect = ({
  differential,
  finished,
  diagnosis,
  first,
  somethingElse,
  deny,
  unsure,
  setDiagnosisTag,
}) => (
  <React.Fragment>
    <OptionLabel fontWeight="regular">
      {headerText(somethingElse, deny, unsure, first)}
    </OptionLabel>
    <OptionContainer>
      {differential &&
        differential.map((d, index) => (
          <Option
            disabled={finished}
            selected={index === diagnosis}
            onClick={() => setDiagnosisTag(index)}
            key={d.diagnosis}
          >
            {d.diagnosis}
          </Option>
        ))}
      {somethingElse && (
        <Option
          disabled={finished}
          selected={diagnosis === "Something else"}
          onClick={() => setDiagnosisTag("Something else")}
        >
          <FormattedMessage
            id="preintent.option.somethingelse"
            defaultMessage="Something else"
          />
        </Option>
      )}
      {deny && (
        <Option
          disabled={finished}
          selected={diagnosis === "No"}
          onClick={() => setDiagnosisTag("No")}
          text="No"
        />
      )}
      {unsure && (
        <Option
          disabled={finished}
          selected={diagnosis === "Unsure"}
          onClick={() => setDiagnosisTag("Unsure")}
        >
          <FormattedMessage
            id="preintent.option.unsure"
            defaultMessage="Unsure"
          />
        </Option>
      )}
    </OptionContainer>
  </React.Fragment>
)

export { DiagnosisSelect as default }



// WEBPACK FOOTER //
// ./assets/feedback/components/tagging/components/DiagnosisSelect.js